<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('payslipTemplate.pageTitle') }}</h4>
        <ts-modal-close-button />
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row">
        <div class="col-md-12">
          <variable-list v-model="model.template_detail" @sort="setNewSort"></variable-list>
          <div class="text-danger" v-if="errors.has('template_detail')">{{ errors.first('template_detail') }}</div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 text-right">
          <ts-button class="mr-2" @click.prevent="$emit('close')">{{ $t('button.cancel') }}</ts-button>
          <ts-button class="btn-primary" :waiting="saving" @click.prevent="update" v-if="updating">
            {{ $t('button.update') }}
          </ts-button>
          <ts-button class="btn-primary" :waiting="saving" @click.prevent="store" v-if="!updating">
            {{ $t('button.save') }}
          </ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import VariableList from './varible-list'
import { Errors } from 'form-backend-validation'

export default {
  name: 'payslipTemplateForm',
  props: ['editData'],
  components: {
    VariableList
  },
  data() {
    return {
      model: {
        template_detail: []
      },
      updating: false,
      saving: false,
      errors: new Errors()
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    setNewSort(value) {
      if (value.length > 0) {
        this.model.template_detail = value
      }
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payslipTemplate/update', {
          id: this.model.template_id,
          data: this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/payslipTemplate/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    fetchData() {
      this.$store.dispatch('hr/payslipTemplate/fetch').catch(error => {
        this.$toasted.error(error.message)
      })
    },
    setEditData() {
      if (!_.isEmpty(this.editData) || !this.editData === undefined) {
        this.updating = true
        this.model = {
          template_id: this.editData.template_id,
          template_detail: this.editData.details
        }
      }
    }
  }
}
</script>
